/**
 * A table: column titles, then rows of pieces.
 */
import { For, Show, type JSX } from "solid-js";
import type { UiNode } from "@protocol/UiNode";
import type { UiContext } from "./context";

/** A table of pieces. */
export function UiTable(props: { columns: string[]; rows: UiNode[][]; ctx: UiContext }): JSX.Element {
  return (
    <table class="ui-table" data-ui="table">
      <Show when={props.columns.length}>
        <thead>
          <tr>
            <For each={props.columns}>{(title) => <th>{title}</th>}</For>
          </tr>
        </thead>
      </Show>
      <tbody>
        <For each={props.rows}>
          {(row) => (
            <tr>
              <For each={row}>{(cell) => <td>{props.ctx.render(cell)}</td>}</For>
            </tr>
          )}
        </For>
      </tbody>
    </table>
  );
}
